/**
 * External dependencies
 */
import { omit } from 'lodash';

/**
 * GeChiUI dependencies
 */
import { useState } from '@gechiui/element';

export const useNavigationTreeNodes = () => {
	const [ nodes, setNodes ] = useState( {} );

	const getNode = ( key ) => nodes[ key ];

	const addNode = ( key, value ) =>
		setNodes( ( original ) => ( {
			...original,
			[ key ]: omit( value, 'children' ),
		} ) );

	const removeNode = ( key ) =>
		setNodes( ( original ) => omit( original, key ) );

	return { nodes, getNode, addNode, removeNode };
};
